//Utilisation de polyfills
import 'classlist-polyfill';
import 'nodelist-foreach-polyfill';
import 'mdn-polyfills/Array.from';
import 'element-dataset';



// WEBPACK FOOTER //
// ./js/loader.js